var app = app || {};

app.fitvids = (function ($) {

	// stupid simple init for fitvids
	fitVids = function() {
        $('.content').fitVids();
	};
    return {
        init: fitVids
    }    	

}( jQuery, this ));


jQuery(app.fitvids.init);